<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <!-- <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>-->
      </template>
      <template slot="right">
        <el-button @click="exportExcel" style="margin-right: 20px;">匯出表單</el-button>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" style="padding: 0;">
        <table id="table-message-list" class="table">
          <thead>
            <tr>
              <th>ID</th>
              <th width="100">姓名</th>
              <th width="45">性別</th>
              <th width="100">生日</th>
              <th width="120">電話</th>
              <th width="200">Email</th>
              <th>年齡</th>
              <th width="70">縣市</th>
              <th width="70">產業</th>
              <th width="90">聯絡時間</th>
              <th width="90px">是否</th>
              <th width="180">時間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in tableData" :key="`message-${data.ID}`">
              <td>{{data.id}}</td>
              <td>{{data.name}}</td>
              <td>{{data.gender}}</td>
              <td>{{data.birthday}}</td>
              <td>{{data.phone}}</td>
              <td>{{data.email}}</td>
              <td>{{data.age}}</td>
              <td>{{data.city}}</td>
              <td>{{data.current_industry}}</td>
              <td>{{data.available_time}}</td>
              <td>{{data.is_ever_contacted | yesorno}}</td>
              <td>{{data.created_at | moment}}</td>
            </tr>
          </tbody>
        </table>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import TableExport from 'tableexport'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      countPerPage: 99999,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null
    }
  },
  computed: {},
  methods: {
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * this.countPerPage, page * this.countPerPage)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.message.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let isFitQuestion = o.Question && o.Question.includes(this.keyword)
        let isFitAnswer = o.Answer && o.Answer.includes(this.keyword)
        return isFitQuestion || isFitAnswer
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.message.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除此訊息 「${obj.Name}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.message.delete(this, obj.id).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.message.list.findIndex(
            o => o.id === obj.id
          )
          if (idx >= 0) this.$store.state.message.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * this.countPerPage,
            this.currentPage * this.countPerPage
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    exportExcel () {
      TableExport.prototype.typeConfig.date.assert = function (value) { return false }
      TableExport.prototype.typeConfig.number.assert = function (value) { return false }

      document.querySelector('.tableexport-caption button').click()

      // var table = TableExport(document.getElementById('table-message-list'))
      // var exportData = table.getExportData()
      // window.table = table
      // console.log(exportData)

      //   var workbook = XLSX.utils.book_new()

      //   /* convert table 'table1' to worksheet named "Sheet1" */
      //   var ws1 = XLSX.utils.table_to_sheet(document.getElementById('table-message-list'))
      //   XLSX.utils.book_append_sheet(workbook, ws1, 'Sheet1')

      //   console.log(ws1)
      //   console.log(workbook)

    //   XLSX.writeFile(workbook, '聯絡訊息.xlsx')
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.message.list
      this.tableData = this.searchedObjs.slice(0, this.countPerPage)
    }
    initTableData()
  },
  mounted () {
    TableExport(document.getElementsByTagName('table'), {
      formats: ['xlsx'],
      filename: '聯絡訊息'
    })
  }
}
</script>

<style>
.tableexport-caption {
  display: none;
}
</style>
